import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';
//import "dayjs/locale/th";

import weekday from "dayjs/plugin/weekday"
import localeData from "dayjs/plugin/localeData"

//import 'moment/locale/th';
import 'antd/dist/reset.css';
import "assets/styles/main.css";
import "assets/styles/responsive.css";
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';

moment.locale("th");

dayjs.extend(weekday)
dayjs.extend(localeData)



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitalskkk
reportWebVitals();
